import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { loadVocabularySectionLessonCards } from '../../services/vocabularyV2';
import LessonFlow from '../../components/LessonFlow';

// Interactive lesson version of one vocabulary section (word list recast as
// intro/recap/mcq cards) — an additional entry point; the reference
// card/list/table views in VocabularyPage stay unchanged.
export default function VocabularyLessonPage() {
  const { t } = useTranslation();
  const { type, categoryId, sectionId } = useParams();
  const { languagePrefs } = useAuth();
  const targetCode = languagePrefs?.targetLanguage || 'en';

  const loader = useCallback(
    () => loadVocabularySectionLessonCards(type, targetCode, categoryId, sectionId),
    [type, targetCode, categoryId, sectionId],
  );

  return (
    <LessonFlow
      loader={loader}
      loaderDeps={[type, targetCode, categoryId, sectionId]}
      backTo="/learn/vocabulary"
      backLabel={t('tools.vocabulary')}
    />
  );
}
